/** zh-CN catalogue `curveEditor` (W3-09; English: src/features/curve-editor/curveEditor.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'curveEditor',
  locale: 'zh-CN',
  messages: {
    columnTitle: '曲线编辑器',
    channelColumnTitle: '通道视图',
    headerTitle: '{prop} · {line}',
    pairName: '{pair, select, position {X 和 Y 位置} other {宽度 W 和高度 H}}',
    headerRegion: '曲线编辑器：{line} 的{prop}',
    lineFallback: '判定线 {index}',
    propName:
      '{prop, select, moveX {X 位置} moveY {Y 位置} rotate {旋转} alpha {不透明度} speed {流速} scaleX {长度 / X 尺寸} scaleY {粗细 / Y 尺寸} color {颜色} text {文字} incline {倾斜} paint {画笔} gif {GIF 进度} other {{prop}}}',
    propNameNormal: '{prop, select, scaleX {长度 / X 尺寸} scaleY {粗细 / Y 尺寸} other {{prop}}}',
    layersLabel: '层级',
    layerChipBase: '基础',
    layerChipShort: '层{n}',
    layerChipHint:
      '{name}：{state, select, keys {有关键帧} other {没有关键帧}}{muted, select, yes {，已在预览中静音} other {}}。单击编辑此层级。',
    layerMuted: '已在预览中静音（不影响导出）',
    sigmaLane: '层级之和',
    sigmaLaneHint: 'Phira 播放的效果：所有层级相加。只读。',
    flattenButton: '合并到层级 0',
    flattenNothing: '只有一个层级：没有可合并的内容。',
    onlyOneLayer: '此属性只有一个层级，没有可相加的内容。',
    channelShowsAll: '通道视图已经显示了每个层级及其总和。',
    flattenHint: '将所有层级之和烘焙到层级 0，并移除其他层级。',
    selectionNone: '单击关键帧或曲线以选中它',
    selectionKeys: '已选中 {count, plural, other {# 个关键帧}}',
    selectionSegments: '已选中 {count, plural, other {# 个区段}}',
    selectionBoth: '已选中 {keys, plural, other {# 个关键帧}}和 {segments, plural, other {# 个区段}}',
    toolbarLabel: '曲线编辑器工具',
    actionsLabel: '选中区段的操作',
    cmdToggle: '展开或收起曲线编辑器',
    cmdExpand: '打开曲线编辑器',
    cmdCollapse: '关闭曲线编辑器',
    cmdChannelView: '通道视图：所有层级并排显示',
    cmdSigma: '显示层级之和',
    cmdGhosts: '淡显其他层级',
    cmdDistance: '显示距离（流速）',
    cmdFitValues: '使数值轴适应可见曲线',
    cmdZoomValuesIn: '放大数值轴',
    cmdZoomValuesOut: '缩小数值轴',
    cmdFlatten: '将层级合并到层级 0',
    cmdMakeBezier: '转换为自定义曲线（贝塞尔）',
    cmdEditBezier: '编辑自定义曲线',
    cmdResetSlice: '使用整条曲线',
    cmdAddLayer: '为此属性添加层级',
    cmdLayer: '在曲线编辑器中编辑另一个层级',
    argLayer: '层级编号',
    cmdReverse: '反转区段',
    cmdLink: '绑定区段',
    cmdDeleteKeys: '删除关键帧',
    btnChangeCurve: '更改缓动…',
    btnHold: '钩定',
    btnJump: '设为跳变',
    btnRemoveJump: '粘合',
    btnBake: '切割…',
    btnReverse: '反转',
    btnLink: '绑定',
    btnAddLayer: '添加层级',
    noFocusedColumn: '请先单击一个运动列',
    noProject: '请先打开一个项目',
    noCurveEditor: '曲线编辑器未打开',
    notNumeric: '{prop}不是数值，因此没有曲线。请在运动列和属性面板中编辑它的关键帧。',
    lineMissing: '此列的判定线已不存在',
    lineLocked: '此判定线已锁定。请在判定线面板中解锁后再编辑。',
    channelNeedsLayers: '通道视图用于由层级相加的属性：X 位置、Y 位置、旋转、不透明度和流速。',
    channelFullOnly: '层级是完整模式的功能。切换到完整模式即可查看通道视图。',
    speedOnly: '只有流速属性有距离曲线。',
    noSegments: '请先选中一个或多个区段',
    noKeys: '请先选中一个或多个关键帧',
    noJumpKeys: '请先选中一个带跳变的关键帧',
    allJump: '选中的关键帧已经是跳变',
    firstKeyJump: '曲线的第一个关键帧不能跳变：没有任何运动到达它。',
    toolMissing: '此工具不可用',
    noBezierSegment: '请选中一个使用自定义曲线的区段',
    noTweenSegments: '请选中一个使用带编号缓动的区段',
    noSlicedSegments: '请选中一个只使用带编号缓动一部分的区段',
    flatSegment: '此区段的起始值和结束值相同，因此无法调整其自定义曲线的形状。请先移动一个关键帧。',
    sliceRefused: 'Phira 无法使用曲线的这一部分。请继续拖动到上升或下降的部分。',
    layerLimit: '在编辑器中，一个属性最多可以有 4 个层级',
    bezierFitted: '已拟合原曲线的自定义曲线（最大差异 {percent}%）',
    bezierNone: '{prop}不能使用自定义曲线',
    arriveFixed: '钩定区段之后，关键帧的到达值就是保持的值。上下拖动可在时间上移动它，拖动右半部分可修改它离开时的值。',
    txMoveKeys: '移动 {count, plural, other {# 个关键帧}}',
    txMoveSegment: '移动区段',
    txBezier: '调整自定义曲线',
    txSlice: '更改曲线的使用部分',
    txAddKey: '添加关键帧',
    txChangeCurve: '更改缓动',
    txMakeBezier: '设为自定义曲线',
    txResetSlice: '使用整条曲线',
    txAddLayer: '添加层级',
    txHold: '钩定',
    txJump: '设为跳变',
    txRemoveJump: '粘合',
    txDeleteKeys: '删除 {count, plural, other {# 个关键帧}}',
    readoutValue: '{beat} = {value}',
    readoutJump: '{beat} = {vin}，然后 {vout}',
    readoutBezier: '控制柄 {handle}：时间 {x}，数值 {y}',
    readoutSlice: '部分 {left} 到 {right}',
    crossScreen: '音符穿过屏幕需要 {sec} 秒',
    crossNever: '音符在此处不会向上移动（速度为 0 或更小）',
    emptyTrack: '{prop}还没有关键帧。双击以添加第一个关键帧。',
    emptyLayer: '此层级没有关键帧。双击以添加一个。',
    readOnlySum: '只读：请在左侧编辑各层级。',
    noEngine: '打开一个项目以查看其曲线。',
    distanceTick: '{value} px',
    curveLinear: '线性',
    curveHold: '钩定',
    curveBezier: '自定义',
    curveGuided: '{strength}，{shape}',
    curveFull: '{name}（{id}）',
    curvePart: '{name}，部分',
    curveBaked: '{name}（导出时烘焙）',
    curveIgnored: '{name}（Phira 按线性播放）',
    easeStrength:
      '{s, select, gentle {轻柔} soft {柔和} medium {适中} strong {较强} stronger {更强} extreme {极强} sharp {陡峭} overshoot {过冲} springy {弹簧} bouncy {弹跳} other {{s}}}',
    easeShape: '{s, select, slowStart {慢起} slowEnd {慢停} slowBoth {两端慢} other {{s}}}',
    unitPx: '{v} px',
    unitDeg: '{v}°',
    unitPercent: '{v}%',
    unitTimes: '×{v}',
    unitPlain: '{v}',
    hintAxisLock: '锁定为单一方向',
    hintRound: '取整数值',
    hintNoSnap: '不吸附',
    hintCancel: '取消',
    settingSigma: '曲线编辑器：显示层级之和',
    settingSigmaHelp: '在你编辑的层级上方用虚线绘制 Phira 播放的数值（所有层级相加）。',
    settingGhosts: '曲线编辑器：显示其他层级',
    settingGhostsHelp: '在你编辑的层级后方淡淡地绘制其他层级的曲线。',
    settingDistance: '曲线编辑器：为流速显示距离',
    settingDistanceHelp: '以虚线曲线添加距离（音符已移动多远），并在底部使用单独的刻度。',
    settingChannel: '曲线编辑器：以通道视图打开',
    settingChannelHelp: '将属性的每个层级并排显示，右侧为只读的总和。',
    helpTitle: '曲线编辑器',
    helpBody:
      '聚焦一个运动列时按 G（或双击其标题）可打开该属性的大图。时间像音符轨道一样向上推进，数值从左到右增大。\n\n拖动关键帧即可移动它：上下改变时间（会吸附到节拍网格），左右改变数值。按住 Ctrl 取整数值，按住 Alt 关闭吸附，按住 Shift 锁定为开始拖动的方向。关键帧永远不会互相越过。\n\n带跳变的关键帧显示为两半：拖动左半部分修改它到达时的值，拖动右半部分修改它离开时的值。钩定区段之后，关键帧的到达值就是保持的值，因此其淡色的左半部分只能在时间上移动它。\n\n右键单击关键帧或曲线，可使用与图表上方工具栏相同的操作：更改缓动、钩定、设为或取消跳变、切割、反转、绑定或删除。\n\n自定义曲线显示两个圆形控制柄；拖动它们即可调整曲线形状。只使用带编号缓动一部分的曲线，会在区段旁显示一条小滑轨，上面的两个方形控制柄用于选择使用的部分。\n\n双击空白处可在不改变运动的情况下添加关键帧，双击曲线可选择另一种缓动。\n\n在引导模式中，“位置”会将 X 和 Y 并排打开（图片判定线的“尺寸”会将 W 和 H 并排打开）。通道视图会并排显示属性的每个层级以及 Phira 播放的总和；“合并到层级 0”会合并这些层级。对于流速，粗曲线是真正推动音符的速度，虚线曲线是距离，播放头处的读数显示音符穿过屏幕需要多长时间。',
  },
};

export default catalog;
